/**
 * GERADO. Não edite à mão.
 *
 * Produzido por `packages/asset-pipeline/src/skins/emit-catalogue-manifest.ts`
 * a partir de `assets-source/skins/<id>/skin.json`, que continua sendo a
 * ÚNICA fonte de geometria, hash e VFX de uma skin.
 *
 * Regenerar:
 *
 *     pnpm assets:prepare
 *
 * `manifest.generated.test.ts` compara este arquivo com o que uma regeração
 * produziria: divergir é teste vermelho, e não uma surpresa em produção.
 *
 * Ele está FORA do Biome (a lista de `includes` de `biome.json` o exclui). O
 * formatador quer chaves sem aspas e aspas simples; este gerador emite
 * `JSON.stringify`. Reproduzir a formatação do Biome aqui seria frágil e
 * criaria um segundo lugar onde a FORMA do arquivo é decidida, brigando com a
 * prova acima - que compara texto. Um artefato gerado não é código que alguém
 * escreveu, e `biome.json` não aceita comentário, então a razão mora aqui.
 */

import type { SkinManifest } from './manifest';

export const GENERATED_SKIN_MANIFEST = {
  "manifestVersion": 1,
  "entries": [
    {
      "definitionId": "skin_cyber_rainbow",
      "status": "ready",
      "contentVersion": 1,
      "asset": {
        "formatVersion": 1,
        "assetKey": "skin-cyber-rainbow",
        "file": "skins/cyber-rainbow.png",
        "sha256": "c99f8feaced31d039f8842fd7fc64d2615a3a2551aeb3405f6af4f571134a589",
        "width": 1254,
        "height": 1254,
        "hasAlpha": true,
        "facing": "up",
        "pivot": {
          "x": 0.5,
          "y": 0.5
        },
        "hullCenter": {
          "x": 0.5,
          "y": 0.5
        },
        "baseScale": 1,
        "visualBounds": {
          "left": 0.015949,
          "top": 0.002392,
          "right": 0.984051,
          "bottom": 0.997608
        },
        "version": 1,
        "note": "PROVISORIO. RISCO: a arte ja desenha dois canos de canhao apontados para a frente, um em cada asa. O canhao autoritativo e desenhado POR CIMA da skin e nao pode ser escondido; o encaixe precisa ser comparado nos tres zooms antes de ser fechado. Nao recortar a arte."
      },
      "vfx": {
        "formatVersion": 1,
        "definitionId": "skin_cyber_rainbow",
        "overlay": {
          "texture": "vfx-core-prismatic",
          "colors": [
            "#3ff0ff",
            "#7a6bff",
            "#ff4fd8",
            "#ffb84f"
          ],
          "alpha": {
            "min": 0.5,
            "max": 0.85
          },
          "scale": {
            "min": 0.08,
            "max": 0.17
          },
          "lifespan": {
            "min": 320,
            "max": 900
          },
          "frequencyHz": 26,
          "speed": {
            "min": 0.02,
            "max": 0.14
          },
          "offset": {
            "forward": 0,
            "lateral": 0
          },
          "spread": 0.06,
          "blend": "add",
          "maxParticles": 40
        },
        "trail": {
          "texture": "vfx-streak",
          "colors": [
            "#3ff0ff",
            "#7a6bff",
            "#ff4fd8",
            "#ffb84f"
          ],
          "alpha": {
            "min": 0,
            "max": 0.82
          },
          "scale": {
            "min": 0.16,
            "max": 0.4
          },
          "lifespan": {
            "min": 1000,
            "max": 1900
          },
          "frequencyHz": 32,
          "offset": {
            "forward": -0.7,
            "lateral": 0
          },
          "minSpeedHullsPerSecond": 0.1,
          "maxLengthHulls": 2,
          "blend": "add",
          "maxParticles": 48,
          "onDiscontinuity": "clear"
        },
        "signatures": [
          {
            "kind": "small_magic_circle",
            "colors": [
              "#3ff0ff",
              "#ff4fd8"
            ],
            "diameter": 0.36,
            "center": {
              "forward": 0,
              "lateral": 0
            },
            "alpha": {
              "min": 0.55,
              "max": 0.8
            },
            "rotationsPerSecond": 0.14,
            "count": 1
          },
          {
            "kind": "energy_pulse",
            "texture": "vfx-streak",
            "colors": [
              "#a970ff",
              "#3ff0ff"
            ],
            "alpha": {
              "min": 0.35,
              "max": 0.7
            },
            "scale": {
              "min": 0.06,
              "max": 0.13
            },
            "lifespan": {
              "min": 160,
              "max": 360
            },
            "frequencyHz": 14,
            "offset": {
              "forward": 0.12,
              "lateral": 0
            },
            "blend": "add",
            "maxParticles": 14
          }
        ],
        "hunt": {
          "frequencyScale": 1,
          "lifespanScale": 1,
          "particleScale": 1,
          "signatures": [
            "small_magic_circle",
            "energy_pulse"
          ]
        },
        "pvp1x1": {
          "frequencyScale": 1,
          "lifespanScale": 1,
          "particleScale": 1,
          "signatures": [
            "small_magic_circle",
            "energy_pulse"
          ]
        },
        "pvp3x3": {
          "frequencyScale": 0.5,
          "lifespanScale": 0.5,
          "particleScale": 0.5,
          "signatures": [
            "small_magic_circle"
          ]
        },
        "lod": {
          "full": {
            "frequencyScale": 1,
            "lifespanScale": 1,
            "particleScale": 1,
            "signatures": [
              "small_magic_circle",
              "energy_pulse"
            ]
          },
          "reduced": {
            "frequencyScale": 0.6,
            "lifespanScale": 0.7,
            "particleScale": 0.6,
            "signatures": [
              "small_magic_circle"
            ]
          },
          "minimal": {
            "frequencyScale": 0.33,
            "lifespanScale": 0.45,
            "particleScale": 0.33,
            "signatures": []
          }
        },
        "fallbackLod": "reduced"
      },
      "compatibility": {
        "assetFormatVersion": 1,
        "vfxFormatVersion": 1
      },
      "note": "Cyber Rainbow. Master do proprietario, 15/08/2026, copiado byte a byte de kenocyber-skin-batch-01/cyber-rainbow/cyber-rainbow.png; a origem chamava-se Skin_CyberRaimbow.png e a grafia fica so como proveniencia. Gerada com assistencia de IA para o KENOCYBER, uso autorizado (LICENSE_CONFIRMATION.md). Geometria FECHADA no gate V24D: centro do alpha exatamente em 0.5/0.5, entao pivo e hullCenter em 0.5 estavam certos e ficam; baseScale continua 1. Ver GEOMETRY.md."
    },
    {
      "definitionId": "skin_golden_wing",
      "status": "ready",
      "contentVersion": 1,
      "asset": {
        "formatVersion": 1,
        "assetKey": "skin-golden-wing",
        "file": "skins/golden-wing.png",
        "sha256": "04e323b5ef9ea2106002479fc31f944273308856e8815404bf660f908c7ab707",
        "width": 1254,
        "height": 1254,
        "hasAlpha": true,
        "facing": "up",
        "pivot": {
          "x": 0.5,
          "y": 0.535885
        },
        "hullCenter": {
          "x": 0.5,
          "y": 0.535885
        },
        "baseScale": 1,
        "visualBounds": {
          "left": 0.004785,
          "top": 0.075758,
          "right": 0.994418,
          "bottom": 0.996013
        },
        "version": 1,
        "note": "PROVISORIO. RISCO 1: a arte ja desenha tubos de canhao dos dois lados; o canhao autoritativo fica por cima e nao pode ser escondido. RISCO 2: o alfa vai de 0.076 a 0.996 na vertical, entao o centro da IMAGEM nao e o centro visual do CASCO. Ver docs/SKIN_INTAKE_BATCH_01.md."
      },
      "vfx": {
        "formatVersion": 1,
        "definitionId": "skin_golden_wing",
        "overlay": {
          "texture": "vfx-core-gold",
          "colors": [
            "#ffe9a8",
            "#fff6e0",
            "#ffd166"
          ],
          "alpha": {
            "min": 0.5,
            "max": 0.85
          },
          "scale": {
            "min": 0.08,
            "max": 0.17
          },
          "lifespan": {
            "min": 320,
            "max": 900
          },
          "frequencyHz": 26,
          "speed": {
            "min": 0.02,
            "max": 0.14
          },
          "offset": {
            "forward": 0,
            "lateral": 0
          },
          "spread": 0.06,
          "blend": "add",
          "maxParticles": 40
        },
        "trail": {
          "texture": "vfx-streak",
          "colors": [
            "#fff6e0",
            "#ffd166",
            "#ffab3d",
            "#ffe9a8"
          ],
          "alpha": {
            "min": 0,
            "max": 0.8
          },
          "scale": {
            "min": 0.16,
            "max": 0.4
          },
          "lifespan": {
            "min": 1000,
            "max": 2000
          },
          "frequencyHz": 29,
          "offset": {
            "forward": -0.7,
            "lateral": 0
          },
          "minSpeedHullsPerSecond": 0.11,
          "maxLengthHulls": 2,
          "blend": "add",
          "maxParticles": 48,
          "onDiscontinuity": "clear"
        },
        "signatures": [
          {
            "kind": "small_magic_circle",
            "colors": [
              "#ffd166",
              "#fff6e0"
            ],
            "diameter": 0.36,
            "center": {
              "forward": 0,
              "lateral": 0
            },
            "alpha": {
              "min": 0.55,
              "max": 0.8
            },
            "rotationsPerSecond": 0.14,
            "count": 1
          },
          {
            "kind": "sparks",
            "texture": "vfx-streak",
            "colors": [
              "#fff6e0",
              "#ffe9a8"
            ],
            "alpha": {
              "min": 0.35,
              "max": 0.7
            },
            "scale": {
              "min": 0.06,
              "max": 0.13
            },
            "lifespan": {
              "min": 150,
              "max": 340
            },
            "frequencyHz": 14,
            "offset": {
              "forward": -0.1,
              "lateral": 0
            },
            "blend": "add",
            "maxParticles": 14
          }
        ],
        "hunt": {
          "frequencyScale": 1,
          "lifespanScale": 1,
          "particleScale": 1,
          "signatures": [
            "small_magic_circle",
            "sparks"
          ]
        },
        "pvp1x1": {
          "frequencyScale": 1,
          "lifespanScale": 1,
          "particleScale": 1,
          "signatures": [
            "small_magic_circle",
            "sparks"
          ]
        },
        "pvp3x3": {
          "frequencyScale": 0.45,
          "lifespanScale": 0.5,
          "particleScale": 0.45,
          "signatures": [
            "small_magic_circle"
          ]
        },
        "lod": {
          "full": {
            "frequencyScale": 1,
            "lifespanScale": 1,
            "particleScale": 1,
            "signatures": [
              "small_magic_circle",
              "sparks"
            ]
          },
          "reduced": {
            "frequencyScale": 0.6,
            "lifespanScale": 0.7,
            "particleScale": 0.6,
            "signatures": [
              "small_magic_circle"
            ]
          },
          "minimal": {
            "frequencyScale": 0.33,
            "lifespanScale": 0.45,
            "particleScale": 0.33,
            "signatures": []
          }
        },
        "fallbackLod": "reduced"
      },
      "compatibility": {
        "assetFormatVersion": 1,
        "vfxFormatVersion": 1
      },
      "note": "Golden Wing. Master do proprietario, 15/08/2026, copiado byte a byte de kenocyber-skin-batch-01/golden-wing/golden-wing.png. Gerada com assistencia de IA para o KENOCYBER, uso autorizado (LICENSE_CONFIRMATION.md). Geometria FECHADA no gate V24D. Unica das tres nao exportada centrada: centro do alpha em 0.535885, contra 0.4814..0.512 dos cascos comuns. Com pivo em 0.5 o centro visivel orbitava a cada giro; pivo e hullCenter passaram a 0.535885. baseScale continua 1. Ver GEOMETRY.md."
    },
    {
      "definitionId": "skin_silver_hunter",
      "status": "ready",
      "contentVersion": 1,
      "asset": {
        "formatVersion": 1,
        "assetKey": "skin-silver-hunter",
        "file": "skins/silver-hunter.png",
        "sha256": "ed6c88017211320f4da0aa8430c38dae548062e27c2dc55677266946d1058b2d",
        "width": 1024,
        "height": 1024,
        "hasAlpha": true,
        "facing": "up",
        "pivot": {
          "x": 0.5,
          "y": 0.5
        },
        "hullCenter": {
          "x": 0.5,
          "y": 0.5
        },
        "baseScale": 1,
        "visualBounds": {
          "left": 0.041016,
          "top": 0.004883,
          "right": 0.959961,
          "bottom": 0.996094
        },
        "version": 1,
        "note": "PROVISORIO. Silhueta limpa, sem arma desenhada na arte: e a unica das tres em que o canhao autoritativo nao disputa espaco com um cano ja pintado."
      },
      "vfx": {
        "formatVersion": 1,
        "definitionId": "skin_silver_hunter",
        "overlay": {
          "texture": "vfx-core-cyan",
          "colors": [
            "#ffffff",
            "#d8ecff",
            "#c9d4ff"
          ],
          "alpha": {
            "min": 0.5,
            "max": 0.85
          },
          "scale": {
            "min": 0.08,
            "max": 0.17
          },
          "lifespan": {
            "min": 320,
            "max": 900
          },
          "frequencyHz": 26,
          "speed": {
            "min": 0.02,
            "max": 0.14
          },
          "offset": {
            "forward": 0,
            "lateral": 0
          },
          "spread": 0.06,
          "blend": "add",
          "maxParticles": 40
        },
        "trail": {
          "texture": "vfx-streak",
          "colors": [
            "#ffffff",
            "#d8ecff",
            "#c9d4ff",
            "#e2d2ff"
          ],
          "alpha": {
            "min": 0,
            "max": 0.78
          },
          "scale": {
            "min": 0.16,
            "max": 0.4
          },
          "lifespan": {
            "min": 900,
            "max": 1900
          },
          "frequencyHz": 31,
          "offset": {
            "forward": -0.7,
            "lateral": 0
          },
          "minSpeedHullsPerSecond": 0.12,
          "maxLengthHulls": 1.6,
          "blend": "add",
          "maxParticles": 48,
          "onDiscontinuity": "clear"
        },
        "signatures": [
          {
            "kind": "small_magic_circle",
            "colors": [
              "#dff0ff",
              "#b9a8ff"
            ],
            "diameter": 0.36,
            "center": {
              "forward": 0,
              "lateral": 0
            },
            "alpha": {
              "min": 0.55,
              "max": 0.8
            },
            "rotationsPerSecond": 0.14,
            "count": 1
          },
          {
            "kind": "sparks",
            "texture": "vfx-streak",
            "colors": [
              "#ffffff",
              "#cfe9ff"
            ],
            "alpha": {
              "min": 0.35,
              "max": 0.7
            },
            "scale": {
              "min": 0.06,
              "max": 0.13
            },
            "lifespan": {
              "min": 140,
              "max": 320
            },
            "frequencyHz": 14,
            "offset": {
              "forward": -0.12,
              "lateral": 0
            },
            "blend": "add",
            "maxParticles": 14
          }
        ],
        "hunt": {
          "frequencyScale": 1,
          "lifespanScale": 1,
          "particleScale": 1,
          "signatures": [
            "small_magic_circle",
            "sparks"
          ]
        },
        "pvp1x1": {
          "frequencyScale": 1,
          "lifespanScale": 1,
          "particleScale": 1,
          "signatures": [
            "small_magic_circle",
            "sparks"
          ]
        },
        "pvp3x3": {
          "frequencyScale": 0.5,
          "lifespanScale": 0.55,
          "particleScale": 0.5,
          "signatures": [
            "small_magic_circle"
          ]
        },
        "lod": {
          "full": {
            "frequencyScale": 1,
            "lifespanScale": 1,
            "particleScale": 1,
            "signatures": [
              "small_magic_circle",
              "sparks"
            ]
          },
          "reduced": {
            "frequencyScale": 0.6,
            "lifespanScale": 0.7,
            "particleScale": 0.6,
            "signatures": [
              "small_magic_circle"
            ]
          },
          "minimal": {
            "frequencyScale": 0.33,
            "lifespanScale": 0.45,
            "particleScale": 0.33,
            "signatures": []
          }
        },
        "fallbackLod": "reduced"
      },
      "compatibility": {
        "assetFormatVersion": 1,
        "vfxFormatVersion": 1
      },
      "note": "Silver Hunter. Master recebido do proprietario em 15/08/2026, copiado byte a byte de E:/WIP/kenocyber-skin-batch-01/silver-hunter/silver-hunter.png. Autoria: gerada com assistencia de IA para o KENOCYBER, uso autorizado pelo proprietario (LICENSE_CONFIRMATION.md). Geometria FECHADA no gate V24D: centro do alpha em 0.5005/0.5005, entao pivo e hullCenter em 0.5 estavam certos e ficam; baseScale continua 1. Medidas em GEOMETRY.md. Draft por decisao de produto, nao por metadado pendente."
    }
  ]
} as const satisfies SkinManifest;
